<template>
    <li class="iu-nav-item">
        <slot></slot>
    </li>
</template>

<script>
export default {
    name: 'IuNavItem',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iu-nav-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    padding: 0 20px;
}
</style>
